var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForkitDarkWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1327.69 357.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #76a6b9;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.45,
    y: 171.5,
    width: 66.2,
    height: 159.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.21,
    y: 58.57,
    width: 156.93,
    height: 58.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.21,
    y: 171.5,
    width: 140.97,
    height: 55.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.45,
    y: 58.57,
    width: 66.2,
    height: 96.77
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371,335.06c-21.55,0-40.7-4.67-57.44-14.02-16.74-9.35-29.98-22.06-39.72-38.16-9.74-16.09-14.6-34.52-14.6-55.3s4.87-39.19,14.6-55.3c9.73-16.09,22.97-28.81,39.72-38.16,16.74-9.35,35.89-14.02,57.44-14.02s40.69,4.67,57.44,14.02c16.75,9.35,29.92,22.07,39.53,38.16,9.6,16.1,14.41,34.53,14.41,55.3s-4.81,39.21-14.41,55.3c-9.61,16.1-22.78,28.81-39.53,38.16-16.74,9.34-35.89,14.02-57.44,14.02ZM371,281.32c9.34,0,17.65-2.34,24.92-7.01,7.27-4.67,12.98-11.03,17.13-19.08,4.15-8.04,6.1-17.26,5.84-27.65.26-10.38-1.69-19.66-5.84-27.84-4.15-8.18-9.87-14.6-17.13-19.28-7.27-4.67-15.58-7.01-24.92-7.01s-17.72,2.33-25.12,7.01c-7.4,4.67-13.18,11.1-17.33,19.28-4.16,8.18-6.1,17.46-5.84,27.84-.26,10.39,1.69,19.6,5.84,27.65,4.15,8.05,9.93,14.41,17.33,19.08,7.4,4.67,15.77,7.01,25.12,7.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M523.25,331.16V124.38h59.19l2.72,67.37-11.68-12.85c3.11-11.16,8.24-21.16,15.38-29.98,7.14-8.82,15.51-15.83,25.12-21.03,9.6-5.19,19.86-7.79,30.76-7.79,4.67,0,9.02.39,13.05,1.17,4.02.78,7.72,1.69,11.1,2.73l-17.13,68.92c-2.86-1.81-6.69-3.31-11.49-4.48-4.81-1.17-9.8-1.75-14.99-1.75-5.71,0-11.04.97-15.97,2.92-4.93,1.95-9.09,4.74-12.46,8.37-3.38,3.64-6.04,7.92-7.98,12.85-1.95,4.93-2.92,10.51-2.92,16.74v103.58h-62.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M700.43,331.16V43h62.31v288.17h-62.31ZM760.4,270.41l-22.97-46.73,96.57-99.3h82.17l-155.77,146.03ZM840.62,331.16l-72.82-94.24,44-34.27,102.41,128.51h-73.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M966.39,190.2c-10.65,0-18.89-2.98-24.73-8.96-5.84-5.97-8.76-14.54-8.76-25.7,0-10.38,3.12-18.82,9.35-25.31,6.23-6.49,14.27-9.74,24.14-9.74,10.64,0,18.95,3.05,24.92,9.15,5.97,6.1,8.96,14.74,8.96,25.9,0,10.12-3.12,18.43-9.35,24.92-6.23,6.49-14.41,9.74-24.53,9.74ZM966.39,335.45c-10.65,0-18.89-2.99-24.73-8.96-5.84-5.97-8.76-14.54-8.76-25.7,0-10.38,3.12-18.82,9.35-25.31,6.23-6.49,14.27-9.73,24.14-9.73,10.64,0,18.95,3.05,24.92,9.15,5.97,6.1,8.96,14.73,8.96,25.89,0,10.12-3.12,18.44-9.35,24.92-6.23,6.48-14.41,9.73-24.53,9.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1078.93,83.5c-11.68,0-20.83-2.79-27.45-8.37-6.62-5.58-9.93-13.56-9.93-23.95,0-9.35,3.37-17,10.13-22.98,6.75-5.97,15.83-8.96,27.26-8.96s20.77,2.79,27.26,8.37c6.49,5.58,9.74,13.43,9.74,23.56,0,9.61-3.31,17.39-9.93,23.36-6.62,5.97-15.64,8.96-27.06,8.96ZM1047.78,331.16V124.38h62.31v206.78h-62.31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1149.02,178.9v-54.52h139.02v54.52h-139.02ZM1185.62,331.16V72.2h62.31v258.96h-62.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkitDarkWordmark);
export default __webpack_public_path__ + "static/media/forkit_dark_wordmark.89d356be06e8d3877a67f91f6a0a171b.svg";
export { ForwardRef as ReactComponent };